import {
  Component, Input, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, EventEmitter, Output
} from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@shared/sliders/entities/slide-models';
import { IMAGE_TYPE } from '@ux/components/image/constants/image-type.constants';
import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { SlideAbstractComponent } from '@shared/sliders/abstracts/slide.abstract';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { StoreRgSlideWidth, StoreSmSlideWidth } from '@ux/components/slide/entities/slide.types';

@Component({
  selector: 'app-slide-store',
  templateUrl: './slide-store.component.html',
  styleUrls: ['./slide-store.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SlideStoreComponent extends SlideAbstractComponent {

  @ViewChild('sectionSlideStore') content: ElementRef;
  @ViewChild('slideStore') cellHeader: ElementRef;

  @Input() stores: Store[];
  @Input() index: number;
  @Input() source: EVENT_SOURCE;
  @Input() isMobile: boolean;
  @Input() salesChannel: string = null;

  @Output() selectedStore: EventEmitter<Store> = new EventEmitter<Store>();

  public typeImageFlight: string = IMAGE_TYPE.FLIGHT;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected router: Router,
    protected imageCdnPipe: ImageCdnPipe,
  ) {
    super(router, changeDetector, imageCdnPipe)
  }

  get slideWidth(): number {
    return this.isMobile ? StoreSmSlideWidth : StoreRgSlideWidth;
  }

  public selectStore(store: Store): void {
    this.selectedStore.emit(store);
    this.selectSlide(store?.deeplink, store?.deeplink_type);
  }

}
